export default {
  orders: [],
  deliveryAddresses: [],
  deliveryCompanies: [],
  currentOrder: null,
  itemsCount: null,
};
